import { GenderSizing } from 'productTemplate/components/buyBar/GenderSizing';
import { SizePreferencesModalProvider } from 'sizePreferences/providers/SizePreferencesModalProvider';

export const BigBuyBarDesktopGenderSizing = () => {
  return (
    <SizePreferencesModalProvider>
      <GenderSizing />
    </SizePreferencesModalProvider>
  );
};
